var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgI2CLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4286 20.7643L12.7704 23.9555L3.29114 16.3856L6.00335 13.0527L15.4286 20.7643Z",
    fill: "#F97C00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0276 13.896L19.4362 15.7851L16.0426 19.9412L6.77246 12.4185L18.8762 8.08031C19.0516 8.01284 19.2203 7.91839 19.389 7.79695C19.5576 7.66876 19.7128 7.52707 19.8477 7.36515C20.1581 6.98733 20.293 6.623 20.2391 6.25868C20.1851 5.8876 19.9557 5.54352 19.5441 5.21967C19.1663 4.92281 18.7683 4.80137 18.3432 4.8486C17.9182 4.88908 17.5538 5.08474 17.2637 5.43557C17.0951 5.63797 16.9939 5.84038 16.9466 6.04953C16.9061 6.25868 16.9264 6.48132 17.0073 6.7377L12.6894 8.32994C12.2036 7.26395 12.0282 6.24518 12.1564 5.26015C12.2913 4.28187 12.7366 3.33732 13.4855 2.43999C14.6595 1.02317 16.137 0.240541 17.9249 0.0718707C19.7061 -0.0900522 21.359 0.422704 22.8771 1.61014C24.3209 2.75035 25.1507 4.15368 25.3666 5.82014C25.5825 7.49334 25.144 8.97763 24.051 10.2865C23.6732 10.7318 23.2279 11.1299 22.7084 11.4605C22.1889 11.791 21.3995 12.1689 20.3335 12.5804L17.0208 13.8826L17.0276 13.896Z",
    fill: "#000823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.5541 23.9555H14.0725L20.4212 16.2236L26.5541 23.9555Z",
    fill: "#000823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8406 15.7581C33.9418 16.7296 33.3886 17.6809 32.4373 18.0452C31.3038 18.477 30.0287 17.9103 29.5969 16.7768C29.1651 15.6434 29.7318 14.3682 30.8653 13.9364C31.8166 13.5721 32.8691 13.9162 33.4358 14.7056L38.867 12.6343C37.1196 8.87635 32.7409 7.05471 28.8075 8.55925C24.6987 10.1312 22.6409 14.7326 24.213 18.8346C25.785 22.9434 30.3863 25.0012 34.4883 23.4292C38.4217 21.9246 40.4727 17.6472 39.265 13.6868L33.8339 15.7581H33.8406Z",
    fill: "#1434CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.53549 15.1779C3.72041 15.1779 4.68097 14.2174 4.68097 13.0324C4.68097 11.8475 3.72041 10.887 2.53549 10.887C1.35058 10.887 0.390015 11.8475 0.390015 13.0324C0.390015 14.2174 1.35058 15.1779 2.53549 15.1779Z",
    fill: "#F97C00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2CLogo);
export default __webpack_public_path__ + "static/media/i2c_logo.a8b2ffb06e43d3138f7af01e045a87e4.svg";
export { ForwardRef as ReactComponent };